<template>
  <v-container class="pa-4 d-flex flex-column" style="height: 100vh">
    <v-row no-gutters class="flex-grow-0">
      <v-col cols="12">
        <v-btn
          fab
          x-small
          :color="site.color"
          @click="redirectTo()"
          dark
          class="mb-4"
        >
          <v-icon large>mdi-chevron-left</v-icon>
        </v-btn>
      </v-col>
    </v-row>

    <v-row no-gutters class="flex-grow-0">
      <v-col class="d-flex justify-center">
        <div style="max-height: 240px">
          <img
            :src="missionDetail.image_url"
            style="
              max-width: 100%;
              max-height: 240px;
              width: auto;
              height: auto;
              border-radius: 10px;
              object-fit: contain;
              display: block;
              margin: 0 auto;
            "
            @error="onImageError($event, missionDetail, 'image_url')"
          />
        </div>
      </v-col>
    </v-row>

    <v-row no-gutters class="mt-3 flex-grow-0">
      <v-col cols="12">
        <v-row no-gutters>
          <v-col cols="12">
            <p class="text-subtitle-1 text--primary mx-0 text-center mb-0">
              {{ missionDetail.name }}
            </p>
          </v-col>
        </v-row>
      </v-col>
    </v-row>

    <v-row
      no-gutters
      class="justify-center mt-3 flex-grow-1"
      style="position: relative; margin-bottom: 80px"
    >
      <div
        style="width: 100%; height: 100%; position: absolute; top: 0; left: 0"
      >
        <VueQRCodeReader
          v-if="false"
          :camera="camera"
          :isReady="isCameraReady"
          :isLoading="isSetLoadingCamera"
          @onDecode="onDecode"
        />
        <JsQRQRCodeReader
          :isReady="isCameraReady"
          :isLoading="isSetLoadingCamera"
          @onDecode="onDecode"
        />
      </div>
    </v-row>

    <v-footer fixed padless color="white">
      <v-container>
        <v-row justify="center">
          <v-col cols="12">
            <v-row class="pt-4" justify="center">
              <v-col cols="11" md="3" class="py-0 pb-4">
                <v-btn
                  block
                  class="pa-5 rounded-lg"
                  :color="site.color"
                  outlined
                  @click="redirectTo()"
                >
                  {{ $t("back") }}
                </v-btn>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-container>
    </v-footer>
  </v-container>
</template>

<script>
import VueQRCodeReader from "../../../components/qrcode-reader/vueQRCodeReader.vue";
import Axios from "@/config/customer-service";
import { mapState } from "vuex";
import JsQRQRCodeReader from "../../../components/qrcode-reader/jsQRQRCodeReader.vue";

export default {
  inject: ["isAppLoading"],
  components: {
    VueQRCodeReader,
    JsQRQRCodeReader,
  },
  data() {
    return {
      missionDetail: {
        id: null,
        name: null,
        mission_status: null,
        schema_survey: null,
        image_url: null,
        image_path: null,
        image_upload: null,
        description: null,
      },
      result: "",
      camera: "rear",
      isCameraReady: true,
      isSetLoadingCamera: false,
    };
  },
  async mounted() {
    this.getMyMissionById(this.$route.params.id);
  },
  methods: {
    redirectTo() {
      this.$router.push({
        name: "my-mission-detail",
        params: {
          id: this.$route.params.id,
        },
      });
    },
    onImageError(event, item, key) {
      if (item && item[key]) {
        item[key] = "";
      } else {
        event.target.style.display = "none";
      }
    },
    async getMyMissionById(id) {
      try {
        const myMission = await Axios.get("mission/getMyMission", {
          params: {
            employee_mission_id: id,
            view_in_period_remind_date: false,
            view_limit_reached: false,
          },
        });
        if (myMission.data?.status == "success") {
          this.missionDetail = myMission.data.data;
          if (this.missionDetail.not_allowed) {
            this.$swal
              .fire({
                icon: "error",
                title: this.$t("messageActivityErrorReJoin"),
                showConfirmButton: false,
                timer: 4000,
              })
              .then(() => {
                this.$router.push({
                  name: "mission",
                });
              });
          }
        }
      } catch (err) {
        console.log("getMissionById", err);
        this.$swal
          .fire({
            icon: "error",
            title: err?.response?.data?.message,
            showConfirmButton: false,
            timer: 4000,
          })
          .then(() => {
            this.$router.push({
              name: "mission",
            });
          });
      }
    },

    // ========== ========== ========== ==========
    async onDecode(result) {
      if (result) {
        var decode;
        decode = result.split("code=").pop().split("&");
        this.result = decode[0];
        this.pause();
        await this.timeout(500);

        const _qrcode = await this.getQrCode(this.result);
        if (_qrcode?.latitude && _qrcode?.longitude && _qrcode?.radius) {
          if (navigator.geolocation) {
            navigator.geolocation.getCurrentPosition(
              (position) => {
                const location = {
                  latitude: position.coords.latitude,
                  longitude: position.coords.longitude,
                };
                this.confirmQRCode(this.result, [
                  location.latitude,
                  location.longitude,
                ]);
              },
              (error) => {
                console.error("Error getting location:", error);
                this.$swal.fire({
                  icon: "error",
                  text: this.$t("locationAccessDenied"),
                  showConfirmButton: false,
                  timer: 5000,
                });
              }
            );
          }
        } else {
          this.confirmQRCode(this.result);
        }
      }
    },
    pause() {
      this.isSetLoadingCamera = true;
      this.camera = "off";
    },
    // ========== ========== ========== ==========

    timeout(ms) {
      return new Promise((resolve) => {
        window.setTimeout(resolve, ms);
      });
    },
    confirmQRCode(textQr, coordinate) {
      let body = {
        employee_mission_id: this.$route.params.id,
        qr_code: textQr,
      };
      if (Array.isArray(coordinate) && coordinate.length > 1) {
        body.latitude = coordinate[0];
        body.longitude = coordinate[1];
      }
      Axios.post("mission/confirmMissionCheckIn", body)
        .then(({ data }) => {
          if (data.status == "success") {
            this.$swal
              .fire({
                icon: "success",
                html: data.message,
                showConfirmButton: false,
                timer: 3000,
              })
              .then(() => {
                this.$router.push({
                  name: "mission",
                });
              });
          } else {
            this.$swal.fire({
              icon: "error",
              text: data.message,
              showConfirmButton: false,
              timer: 3000,
            });
          }
        })
        .catch(() => {
          this.$router.push({
            name: "mission",
          });
        });
    },
    getQrCode(textQr) {
      return new Promise((resolve) => {
        Axios.get("mission/getQrCode", {
          params: {
            employee_mission_id: this.$route.params.id,
            qr_code: textQr,
          },
        })
          .then(({ data }) => {
            let response = null;
            if (data.status == "success") {
              response = data.data;
            }
            resolve(response);
          })
          .catch((err) => {
            console.log("getQRCode", err);
            resolve(null);
          });
      });
    },
  },
  computed: {
    ...mapState("defaultSystem", ["site"]),
  },
  filters: {},
};
</script>

<style scoped>
</style>